import { connect } from 'react-redux';
import { actions } from '../../../../../../redux/modules/administrativos/administrativos';
import { getMe } from "../../../../../../redux/modules/cuenta/login";
import AdministrativosCrear from './AdministrativosCrear';

const mstp = state => {
    return {...state.administrativos}
};

const mdtp = {
    ...actions, getMe
};

export default connect(mstp, mdtp)(AdministrativosCrear)
